/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAction, createSlice, createSelector } from '@reduxjs/toolkit';

import createRequestActionTypes from 'store/helpers/createRequestActionTypes';
import {
  onSuccess,
  onSuccessList,
  handleClearErrors,
  onFailure,
  onSuccessDetail,
} from 'store/helpers/commonHandlers';
import getSplicedList from 'lib/utils/getUpdatedList';

const name = 'doctors';

/** ActionType for Request */
export const [
  GET_MY_DOCTOR_DATA,
  GET_MY_DOCTOR_DATA_SUCCESS,
  GET_MY_DOCTOR_DATA_FAILURE,
] = createRequestActionTypes(name, 'GET_MY_DOCTOR_DATA');
export const [
  GET_DOCTOR_LIST,
  GET_DOCTOR_LIST_SUCCESS,
  GET_DOCTOR_LIST_FAILURE,
] = createRequestActionTypes(name, 'GET_DOCTOR_LIST');
export const [
  GET_DOCTOR_DETAIL,
  GET_DOCTOR_DETAIL_SUCCESS,
  GET_DOCTOR_DETAIL_FAILURE,
] = createRequestActionTypes(name, 'GET_DOCTOR_DETAIL');
export const [
  GET_SUMMARIZE_DOCTOR_LIST,
  GET_SUMMARIZE_DOCTOR_LIST_SUCCESS,
  GET_SUMMARIZE_DOCTOR_LIST_FAILURE,
] = createRequestActionTypes(name, 'GET_SUMMARIZE_DOCTOR_LIST');
export const [
  CREATE_DOCTOR_PROFILE,
  CREATE_DOCTOR_PROFILE_SUCCESS,
  CREATE_DOCTOR_PROFILE_FAILURE,
] = createRequestActionTypes(name, 'CREATE_DOCTOR_PROFILE');
export const [
  UPDATE_DOCTOR_PROFILE,
  UPDATE_DOCTOR_PROFILE_SUCCESS,
  UPDATE_DOCTOR_PROFILE_FAILURE,
] = createRequestActionTypes(name, 'UPDATE_DOCTOR_PROFILE');
export const [
  DELETE_DOCTOR_HOLIDAY,
  DELETE_DOCTOR_HOLIDAY_SUCCESS,
  DELETE_DOCTOR_HOLIDAY_FAILURE,
] = createRequestActionTypes(name, 'DELETE_DOCTOR_HOLIDAY');
export const [
  DELETE_DOCTOR_TIME,
  DELETE_DOCTOR_TIME_SUCCESS,
  DELETE_DOCTOR_TIME_FAILURE,
] = createRequestActionTypes(name, 'DELETE_DOCTOR_TIME');

const slice = createSlice({
  name,
  initialState: {
    mine: null,
    list: null,
    summarizeList: null,
    doctorDetails: {},
    errors: {},
    count: {},
    next: {},
  },
  reducers: {
    clearErrors: handleClearErrors,
  },
  extraReducers: {
    [GET_MY_DOCTOR_DATA_SUCCESS]: onSuccess('mine'),
    [GET_DOCTOR_LIST_SUCCESS]: onSuccessList('list'),
    [GET_SUMMARIZE_DOCTOR_LIST_SUCCESS]: onSuccessList('summarizeList'),
    [GET_DOCTOR_DETAIL_SUCCESS]: onSuccessDetail('doctorDetails', 'id'),
    [GET_DOCTOR_DETAIL_FAILURE]: onFailure('doctorDetail'),
    [CREATE_DOCTOR_PROFILE_SUCCESS]: (state, { payload }) => {
      state.list = getSplicedList(state.list, payload);
      state.summarizeList = getSplicedList(state.summarizeList, payload);
    },
    [CREATE_DOCTOR_PROFILE_FAILURE]: onFailure('createDoctorProfile'),
    [UPDATE_DOCTOR_PROFILE_FAILURE]: onFailure('updateDoctorProfile'),
    [UPDATE_DOCTOR_PROFILE_SUCCESS]: (state, { payload }) => {
      state.summarizeList = getSplicedList(state.summarizeList, payload);
      state.list = getSplicedList(state.list, payload);
    },
    [DELETE_DOCTOR_HOLIDAY_FAILURE]: onFailure('deleteDoctorHoliday'),
    [DELETE_DOCTOR_TIME_FAILURE]: onFailure('deleteDoctorTime'),
  },
});

/** Action for Request */
export const getMyDoctorData = createAction(GET_MY_DOCTOR_DATA);
export const getDoctorList = createAction(GET_DOCTOR_LIST);
export const getSummarizeDoctorList = createAction(GET_SUMMARIZE_DOCTOR_LIST);
export const getDoctorDetail = createAction(GET_DOCTOR_DETAIL);
export const createDoctorProfile = createAction(CREATE_DOCTOR_PROFILE);
export const updateDoctorProfile = createAction(UPDATE_DOCTOR_PROFILE);
export const deleteDoctorHoliday = createAction(DELETE_DOCTOR_HOLIDAY);
export const deleteDoctorTime = createAction(DELETE_DOCTOR_TIME);

/** General Action */
export const { clearErrors } = slice.actions;

/** Reducer */
export const doctors = slice.reducer;

/** Selectors */
const errorSelector = createSelector(
  (state) => state.errors,
  (errors) => ({ errors }),
);
const myDataSelector = createSelector(
  (state) => state.mine,
  (mine) => ({ mine }),
);
const listSelector = createSelector(
  (state) => state.list,
  (state) => state.count.list,
  (list, count) => ({ doctorList: list, doctorCount: count }),
);
const summarizeSelector = createSelector(
  (state) => state.summarizeList,
  (summarizeList) => ({ summarizeDoctorList: summarizeList }),
);
const detailSelector = createSelector(
  (state) => state.doctorDetails,
  (doctorDetails) => ({ doctorDetails }),
);
export const selectors = {
  errors: (state) => errorSelector(state[name]),
  myData: (state) => myDataSelector(state[name]),
  list: (state) => listSelector(state[name]),
  summarizeList: (state) => summarizeSelector(state[name]),
  details: (state) => detailSelector(state[name]),
};

export default slice;
